module.exports = __webpack_public_path__ + "img/acuerdo.1cc99ba4.png";